module.exports = __webpack_public_path__ + "static/media/S (60).fa1b64b0.jpg";